var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFEDED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 34,
    fill: "#F5D6D3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 11.25,
    r: 11.25,
    transform: "matrix(1 0 0 -1 28.75 51.25)",
    stroke: "#EF4744"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 45.625C40.625 45.2798 40.3452 45 40 45C39.6548 45 39.375 45.2798 39.375 45.625C39.375 45.9702 39.6548 46.25 40 46.25C40.3452 46.25 40.625 45.9702 40.625 45.625Z",
    fill: "#F24646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33.75V42.5",
    stroke: "#EF4744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.f013058ab21fc7e669a4f1ca02fdb3ed.svg";
export { ForwardRef as ReactComponent };